/** @jsx jsx */
import { Badge, Text, jsx } from "theme-ui";
import { get } from "sites-common/utils/lodash";
import { doFormatTitle } from "@heartfulnessinstitute/react-hfn-forms/dist/formatting";
import {
  abhyasStage,
  NEWPRACTITIONER,
  PRACTITIONER,
  SEEKER,
  TRAINER,
  ageGroup,
} from "sites-common/utils/validations";
import { Stack, StackItem } from "office-ui-fabric-react";

function renderPersonResultPlain(item, showRef = false) {
  const aStage = abhyasStage(item?.record_type, item?.ref);
  const colorCode =
    aStage === TRAINER
      ? "red"
      : get({ M: "darkblue", F: "purple" }, item?.gender, "magenta");
  return (
    <Stack horizontal horizontalAlign="space-between">
      <StackItem>
        <Text variant="title">{doFormatTitle(item?.name || "")}</Text>
        <div>
          {item?.gender}{" "}
          {item?.age_group ? item.age_group : ageGroup(item?.age)} ⋆ ⋅ ☆ ⋅ ⋆{" "}
          {[item?.city?.name || item?.city_id?.name]}
        </div>
      </StackItem>
      <StackItem sx={{ textAlign: "right" }}>
        <div>
          <Badge sx={{ bg: colorCode, mt: 1 }}>
            {aStage === TRAINER && "Preceptor"}
            {aStage === PRACTITIONER && "Practitioner"}
            {aStage === NEWPRACTITIONER && "New Practitioner"}
            {aStage === SEEKER && "New Seeker"}
          </Badge>
        </div>
        {showRef && (
          <Text
            variant="subtitle"
            sx={{ ml: 2, fontSize: "0.8em", color: colorCode, fontWeight: 700 }}
          >
            {item?.ref}
          </Text>
        )}
      </StackItem>
    </Stack>
  );
}

export default renderPersonResultPlain;
